import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/energyTransitionRenewable/icon3_01.png'
import _imports_1 from '../../assets/energyTransitionRenewable/icon3_02.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "kv" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "投入再生能源")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "sect1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ctx" }, [
    /*#__PURE__*/_createElementVNode("p", null, "和平電廠具有 20 年豐富的電廠運轉及長期穩定供電經驗。"),
    /*#__PURE__*/_createElementVNode("p", null, "我們依循母公司台泥 發展多元綠電的政策方向，以「火」為基石，加入永續能源「光」與「水」，因為我們知道再生能源的佔比越高，每一度電產生的排碳量就會越低，和平電力不放過廠內任何一絲被忽略的能量，轉成可再利用的電能。")
  ])
], -1)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "電廠內盡其可能建置光電設備", -1)
const _hoisted_6 = { class: "sect3" }
const _hoisted_7 = { class: "ctx" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "綠電自發自用 屋頂光電與小水力", -1)
const _hoisted_9 = { class: "renewable" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"item\"><div class=\"icon\"><img src=\"" + _imports_0 + "\"></div><div class=\"desp\"><div class=\"itemTit\">屋頂光電</div><p>和平電力設置自發、自用的再生能源發電設備，提供廠內輔機設備用電，屋頂全面建置太陽能板，預計設置裝置容量 1809kW，預估年發電量為 201 萬度，2025 年太陽光電系統發電量已達 84.2 萬度。</p></div></div>", 1)
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_13 = { class: "desp" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "itemTit" }, "小水力", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "電廠運作需要大量的冷卻水進行降溫，這些水的來源是海水，使用過後的冷卻水按照政府規定的排放標準，直接透過專屬渠道排回大海，為增加利用效益，和平電力規劃複合式再生能源發電，在既有渠道上設置小水力發電機組，藉由冷卻循環水圍堰的位能差轉換為電能，併接廠內用電系統自發自用。", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "預計 2028 年完工，裝置容量 576kW，預估年發電量 390 萬度。", -1)
const _hoisted_17 = { class: "explain" }
const _hoisted_18 = { class: "imgContainer3-1" }
const _hoisted_19 = { class: "info" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, "併接高壓系統"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "txt2" }, "位能差發電")
], -1)
const _hoisted_21 = { class: "data" }
const _hoisted_22 = {
  class: "num",
  ref: "num"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "imgContainer3-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "imgTit" }, "冷卻循環水圍堰")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 1,
            autoplay: {delay:3000, disableOnInteraction:false},
            speed: 1000,
            loop: true,
            pagination: {clickable:true},
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "swiper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "cover cover1" }),
              _createVNode(_component_swiper_slide, { class: "cover cover2" }),
              _createVNode(_component_swiper_slide, { class: "cover cover3" }),
              _createVNode(_component_swiper_slide, { class: "cover cover4" })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createTextVNode("預估 "),
                        _createElementVNode("span", _hoisted_22, "3900000", 512),
                        _createTextVNode(" 度/年")
                      ])
                    ])
                  ]),
                  _hoisted_23
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}